/**
 * "A first sync into an existing account is expected" (local mode, Settings → Sync: logging in or joining
 * with a passphrase). The welcome gate shows the "Syncing data…" screen while it is set, like after the same
 * step on the welcome page, so the user never sees the app with settings the account has not delivered yet.
 * In-memory only: a reload starts the app normally and the sync engine finishes the first sync by itself.
 */

let expected = false;
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of [...listeners]) listener();
}

export function isFirstSyncExpected(): boolean {
  return expected;
}

export function expectFirstSync(): void {
  expected = true;
  notify();
}

export function clearFirstSyncExpected(): void {
  if (!expected) return;
  expected = false;
  notify();
}

export function subscribeFirstSyncExpected(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
